export default {
  allContracts: state => state.contracts,
  currentExtractData: state => state.currentExtract,
  isLoadingStatus: state => state.isLoadingStatus,
  isLoadingContractDetails: state => state.isLoadingContractDetails
}



// WEBPACK FOOTER //
// ./src/store/modules/combo_extract/getters.js